module.exports = __webpack_public_path__ + "media/images/navigator-c5ed8e128e2f4c02fec5b4526a9a1596.svg";